import { createContext, useState, useEffect, ReactNode } from 'react';
import { useLocation, useParams } from 'react-router';
import { userBookingAxios } from 'APIs';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

interface Chef {
  firstName: string;
  lastName: string;
}

interface BillingAddress {
  address: string;
  city: string;
  zip: string;
  region: string;
}

interface Venue {
  address: string;
  city: string;
  zip: string;
  region: string;
}

interface FareObject {
  advance?: number | string;
  remainingFare?: number | string;
  chefFare?: number | string;
  additionalServicesFare?: number | string;
  tax?: number | string;
  total?: number | string;
  totalPrice?: number | string;
}

interface Coupon {
  code?: string;
  discountAmount?: number | string;
}

interface UsersDetail {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  address: string;
  city: string;
  region: string;
  zip: string;
  requirement?: string;
  meals?: string[];
  headCount?: string;
  startDate?: string;
  startTime?: string;
  endTime?: string;
  chef?: Chef;
  chefRating?: { rating: string };
  additionalServices?: string;
  createdAt?: string;
  baseFare?: string;
  description?: string;
  finalFare?: string;
  menu?: string;
  billingAddress?: BillingAddress;
  venue?: Venue;
  fareObject?: FareObject;
  coupon?: Coupon;
  user?: UsersDetail;
}

interface UserBookingDetails {
  address: string;
  chef: string;
  startDate: string;
  startTime: string;
  requirement: string;
  meals: string;
  headCount: string;
  additionalServices: string;
  baseFare: string;
  coupon: string;
  description: string;
  finalFare: string;
}

interface userDetail {
  isLoading: boolean;
  status: number;
  error: boolean;
  data: UsersDetail;
}

interface userBookingDetails {
  isLoading: boolean;
  status: number;
  error: boolean;
  data: UserBookingDetails;
}

interface BookingsContextProps {
  userDetail: userDetail;
  userBookings: userBookingDetails;
  assignChef:(chefId:string) => Promise<void>;
}

const USER_DATA_MODAL = {
  isLoading: true,
  status: 0,
  error: false,
  data: {
    id: '',
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    address: '',
    city: '',
    region: '',
    zip: '',
  },
};

const USER_BOOKINGS_MODAL: userBookingDetails = {
  isLoading: true,
  status: 0,
  error: false,
  data: {
    address: '',
    chef: '',
    startDate: '',
    startTime: '',
    requirement: '',
    meals: '',
    headCount: '',
    additionalServices: '',
    baseFare: '',
    coupon: '',
    description: '',
    finalFare: '',
  },
};

export const BookingsContextDetail = createContext<
  BookingsContextProps | undefined
>(undefined);

export const BookingsDetailProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [userDetail, setUserData] = useState<userDetail>(USER_DATA_MODAL);
  const [userBookings, setUserBookings] =
    useState<userBookingDetails>(USER_BOOKINGS_MODAL);
    const navigate = useNavigate();

  const location = useLocation();
  console.log('location.........', location);
  const { bookingId } = useParams();
  console.log('booking id..........', bookingId);
  useEffect(() => {
    const fetchUserData = async () => {
      console.log('customer Id Context', bookingId);
      try {
        const response = await userBookingAxios.get(`/bookings/${bookingId}`);
        const {
          data: { error, data },
          status,
        } = response;
        setUserData({
          isLoading: false,
          status: status,
          error: error,
          data: data.booking,
        });
        setUserBookings({
          isLoading: false,
          status,
          error,
          data: data.bookingDetails, // adjust based on API response
        });

        console.log(',.,.,..', data.booking);
      } catch (err) {
        console.log('Error fetching user data', err);

        if(axios.isAxiosError(err)){
          const status = err.response?.status;

          if(status === 401){
            localStorage.clear();
            navigate('/')
            return;
          }
        }
      }
    };

    fetchUserData();
  }, [bookingId,navigate]);


  const assignChef = async(chefId:string) => {
    if(!bookingId) throw new Error('Invalid booking Id');

    try {
      await userBookingAxios.put(`/bookings/${bookingId}`,{
        chef:chefId
      });
      setUserData(prev => ({
        ...prev,
        data:{
          ...prev.data,
          chef:{firstName:'',lastName:''},
        },
      }));
    } catch (error) {
      console.log("Assing Chef",error)
      throw error;
    }
  }


  const updateData = async () => {
    console.log('customer id COntext',bookingId)
    try {
      console.log("chef ID")
    } catch (error) {
      
    }
  }

  updateData()

  return (
    <BookingsContextDetail.Provider value={{ userDetail, userBookings,assignChef }}>
      {children}
    </BookingsContextDetail.Provider>
  );
};
